<template>
  <div>
    <feather-icon
      v-if="icon"
      :icon="docStatus(status).icon"
      :class="`text-${docStatus(status).color}`"
      size="16"
    />
    <b-badge
      v-else
      :variant="docStatus(status).color"
      class="d-block"
    >
      {{ docStatus(status).text }}
    </b-badge>
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import { docStatus } from '@core/utils/filter'

export default {
  components: {
    BBadge,
  },
  props: {
    status: {
      type: [String, null],
      default: null,
    },
    icon: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      docStatus,
    }
  },
}
</script>
